import {
  SET_NAVVIS_API_TOKEN,
  SET_SECONDARY_VIEW_VISIBILITY,
  SET_SPLIT_INDOORVIEWER,
  SET_CLICKED_ITEM_TYPE,
  SET_CURRENT_LEVEL_IV_FRAME1,
  SET_CURRENT_LEVEL_IV_FRAME2,
  SET_POIS_FOR_SELECTED_BUILDING_IVION,
  SET_POIS_FOR_SELECTED_REAL_ESTATE_IVION,
  SET_ROUTE,
  RESET_ROUTE,
  CHANGE_PRIMARY_INSTANCE,
  CHANGE_SECONDARY_INSTANCE,
  SET_IV_LEVELS_FOR_FRAME,
  SET_IVION_LINKS,
  SET_PRIMARY_INSTANCE_POSITION,
  SET_PRIMARY_INSTANCE_ORIENTATION
} from '../mutation-types'
import {
  CHANGE_LEVEL,
  CHANGE_LEVEL_IV,
  CHANGE_LEVEL_IV_FRAME2,
  CHANGE_POI,
  GET_POIS_FOR_SELECTED_BUILDING,
  INIT_CONTEXTMENU,
  INIT_DISRUPTIVE_SENSORS,
  LOAD_IV_COMPONENTS,
  RESET_IVION_INSTANCES,
  SET_IV_LEVELS
} from '../action-types'
import { ivApi, ivApi2, ivInstance } from '@/components/indoorviewer/IndoorviewerView.vue'
import { login } from '@/utils/navvis-helper'
import { getPoisGeojsonForBuilding } from '@/services/pois.service'
import { getPoiWithAddedProperties } from '@/utils/data'

export default {
  namespaced: true,
  state: {
    ivLevelsFrame1: null,
    ivLevelsFrame2: null,
    navvisApiToken: '',
    poiTypes: [],
    hasIvLoaded: false,
    route: null,
    numberOfInstances: 0,
    poisForSelectedBuildingIvion: [],
    poisForSelectedRealEstateIvion: [],
    instanceLinks: [],
    primaryInstancePosition: null,
    primaryInstanceOrientation: null,
    primaryInstance: null,
    secondaryInstance: null,
    selectedLevelIvFrame1: null,
    selectedLevelIvFrame2: null,
    splitIndoorViewer: false
  },
  getters: {
    isSplitIndoorViewer(state) {
      return state.splitIndoorViewer
    },
    navvisInstanceURL(state) {
      return state.primaryInstance != null ? state.instanceLinks[state.primaryInstance].link : null
    },
    navvisInstanceURL2(state) {
      return state.secondaryInstance != null
        ? state.instanceLinks[state.secondaryInstance].link
        : null
    }
  },
  mutations: {
    [SET_IV_LEVELS_FOR_FRAME](state, payload) {
      if ((payload.frame = 1)) state.ivLevelsFrame1 = payload.floors
      if ((payload.frame = 2)) state.ivLevelsFrame2 = payload.floors
    },
    [SET_PRIMARY_INSTANCE_ORIENTATION](state, payload) {
      state.primaryInstanceOrientation = payload
    },
    [SET_PRIMARY_INSTANCE_POSITION](state, payload) {
      state.primaryInstancePosition = payload
    },
    [SET_IVION_LINKS](state, payload) {
      const links = []
      payload.forEach((linkObj, index) => {
        links.push({ link: linkObj.link, title: linkObj.title ? linkObj.title : null })
      })
      state.instanceLinks = links
      state.primaryInstance = state.instanceLinks.length ? state.instanceLinks.length - 1 : null
      state.secondaryInstance = state.primaryInstance
    },
    // Takes a payload to reset selected instance: Null
    [CHANGE_PRIMARY_INSTANCE](state, instanceNumber) {
      // check if instanceNumber is zero needed for url otherwise zero becomes falsy
      state.primaryInstance = instanceNumber >= 0 ? instanceNumber : null
    },
    [CHANGE_SECONDARY_INSTANCE](state, instanceNumber) {
      state.secondaryInstance = instanceNumber >= 0 ? instanceNumber : null
    },
    // Takes a payload with token: String
    [SET_NAVVIS_API_TOKEN](state, payload) {
      state.navvisApiToken = payload.token
    },
    [SET_POIS_FOR_SELECTED_BUILDING_IVION](state, payload) {
      state.poisForSelectedBuildingIvion = payload
    },
    [SET_POIS_FOR_SELECTED_REAL_ESTATE_IVION](state, payload) {
      state.poisForSelectedRealEstateIvion = payload
    },
    [SET_CURRENT_LEVEL_IV_FRAME1](state, payload) {
      state.selectedLevelIvFrame1 = payload.levelNumber
    },
    [SET_CURRENT_LEVEL_IV_FRAME2](state, payload) {
      state.selectedLevelIvFrame2 = payload.levelNumber
    },
    /* TODO Unsure if it should be placed in store, but could be good to keep iv in the same place and for future references. */
    // Takes a payload with isVisible: boolean
    [SET_SECONDARY_VIEW_VISIBILITY](state, payload) {
      if (ivApi) {
        ivApi.view.service.ViewService.showSecondaryView = payload.isVisible
      }
    },
    // Takes a payload with splitIndoorViewer: Boolean
    [SET_SPLIT_INDOORVIEWER](state, payload) {
      state.splitIndoorViewer = payload.splitIndoorViewer
    },
    [SET_ROUTE](state, payload) {
      // Cannot store entire reactive route object, is causing app breakdown
      let instructions = payload.route.instructions.map((obj) => {
        return {
          text: obj.text,
          type: obj.type,
          floor: obj.floor.name,
          icon: obj.icons ? obj.icons.text : ''
        }
      })
      let routeLength = payload.route.routeLength
      state.route = { instructions: instructions, length: routeLength }
    },
    [RESET_ROUTE](state) {
      state.route = null
    },
    setPoiTypesVisibility(state, types) {
      state.poiTypes = types
    },
    setIvLoaded(state, isLoaded) {
      state.hasIvLoaded = isLoaded
    }
  },
  actions: {
    // Takes a payload levelNumber: String, the level of the selected floor and  fromMap: boolean, if request not sent from iv module.
    [CHANGE_LEVEL_IV]({ commit, dispatch, rootState }, payload) {
      commit(SET_CURRENT_LEVEL_IV_FRAME1, { levelNumber: payload.levelNumber })
      if (ivApi && ivApi.view.floorChangerService.FloorChangerService) {
        ivApi.view.floorChangerService.FloorChangerService.changeFloorByName(payload.levelNumber)
          .then(() => {})
          .catch(() => {})
      }
      if (!Object.keys(rootState.mapview.selectedBuilding).length > 0) return // Floor picker hidden for real estate
      dispatch(CHANGE_LEVEL, { levelNumber: payload.levelNumber }, { root: true })
      commit(SET_CLICKED_ITEM_TYPE, { type: 'level' }, { root: true })
    },
    [CHANGE_LEVEL_IV_FRAME2]({ commit }, payload) {
      commit(SET_CURRENT_LEVEL_IV_FRAME2, payload)
      if (ivApi2 && ivApi2.view.floorChangerService.FloorChangerService) {
        ivApi2.view.floorChangerService.FloorChangerService.changeFloorByName(payload.levelNumber)
          .then(() => {})
          .catch(() => {})
      }
    },
    async [GET_POIS_FOR_SELECTED_BUILDING]({ commit, rootGetters }) {
      const pois = await getPoisGeojsonForBuilding(rootGetters['mapview/selectedBuildingId'])
      commit(SET_POIS_FOR_SELECTED_BUILDING_IVION, pois)
    },
    [INIT_DISRUPTIVE_SENSORS]() {
      login(ivApi)
    },
    async initPoiTypes({ commit, state, getters }) {
      try {
        const poiTypeGroups = await ivApi.poi.poiTypeGroupRepository.findAll()
        const poiTypes = await ivApi.poi.poiTypeRepository.findAll()
        const poiTypeOptions = []
        poiTypeGroups.forEach((group) => {
          const types = []
          poiTypes.forEach((type) => {
            if (type.poiTypeGroupId !== group.id) return
            // Alternative icon source if poi type._icon is undefined
            let iconSrc = require('@/assets/minus.svg')
            let instanceUrl = getters.navvisInstanceURL
            instanceUrl = instanceUrl.split('?')[0]
            if (type._icon) {
              iconSrc = type._icon?.includes('poi_navvis')
                ? instanceUrl + type._icon
                : instanceUrl + type._icon + '?x_authorization=' + state.navvisApiToken
            }
            types.push({
              id: type.id,
              name: type.name,
              visible: true,
              iconSrc
            })
          })
          poiTypeOptions.push({
            id: group.id,
            name: group.name,
            types,
            visible: true
          })
        })
        commit('setPoiTypesVisibility', poiTypeOptions)
      } catch (e) {
        console.error(e)
      }
    },
    [INIT_CONTEXTMENU]() {
      // Removes the "create POI" from context menu
      // ivApi.view.mainView.layerPoi.onContextMenu = function () { return true }
      // Removes the "Hide current location" from context menu
      if (ivApi.view.service.ViewService.mainView.layerCameraImage?.onContextMenu)
        ivApi.view.service.ViewService.mainView.layerCameraImage.onContextMenu = function () {
          return true
        }
    },
    [LOAD_IV_COMPONENTS]({ commit, dispatch, rootState, state }) {
      if (ivApi) {
        dispatch('initPoiTypes')
        commit('setIvLoaded', true)
        dispatch(INIT_CONTEXTMENU)
        // dispatch(INIT_DISRUPTIVE_SENSORS) As none of the instances has sensors atm this line is commented out

        // Initialization of callback functions
        ivApi.poi.service.onPoiClick.connect(function (poi) {
          if (poi.descriptions.en)
            poi.descriptions.en = poi.descriptions.en
              .replace(/<img.*<\/img>/g, '') // Removing image tag due to BIMobject issues (old connection for validated pois, for example in AWL)
              .replace(/<a.*<\/a>/g, '') // Excluding links due to BIMobject issues (old connection for validated pois, for example in AWL)
          if (poi.descriptions.sv)
            poi.descriptions.sv = poi.descriptions.sv
              .replace(/<img.*<\/img>/g, '') // Removing image tag due to BIMobject issues (old connection for validated pois, for example in AWL)
              .replace(/<a.*<\/a>/g, '') // Excluding links due to BIMobject issues (old connection for validated pois, for example in AWL)
          const shouldConnectBuildingPois =
            Object.keys(rootState.mapview.selectedBuilding).length > 0 // If not building, we currently expect real estate
          let poiBackend = shouldConnectBuildingPois
            ? state.poisForSelectedBuildingIvion?.find(
                (poiBackend) => poiBackend.properties.navVisId === poi.id // For pois only: navVisId equals id instead of siteModelEntityId on backend
              )
            : state.poisForSelectedRealEstateIvion?.find(
                (poiBackend) => poiBackend.properties.navVisId === poi.id // For pois only: navVisId equals id instead of siteModelEntityId on backend
              )
          if (poiBackend) {
            poiBackend = getPoiWithAddedProperties(
              poiBackend,
              shouldConnectBuildingPois
                ? rootState.planview.poiCategoriesForSelectedLevel
                : rootState.mapview.poiCategoriesForSelectedRealEstate
            )
          }
          dispatch(CHANGE_POI, { poi: poiBackend ? poiBackend.properties : poi }, { root: true }) // Using backend poi if matching id:s
          commit(SET_CLICKED_ITEM_TYPE, { type: 'poi' }, { root: true })
        })
        // Prepared function catching the moment a POI is saved – be aware that the actual function should not be made on connect!
        // ivApi.poi.service.onPoiSave.connect(function (poi) {})
        // Prepared function catching the moment a POI is deleted – be aware that the actual function should not be made on connect!
        // ivApi.poi.service.onPoiDelete.connect(function (poi) {})
        // Old solution for changing floors below – generated problems due to being triggered on initial indoorviewer load (unwanted CHANGE_LEVEL)
        /*
        ivApi.view.floorChangerService.onFloorChange.connect(function (floor) {
          if (floor.currentFloors.length > 0) {
            dispatch(CHANGE_LEVEL_IV, {
              levelNumber: floor.currentFloors[0].name
            })
          }
        })
        */
        if (ivApi.routing) {
          // Old instances (< 2.5) don't support routing
          ivApi.routing.onRouteChanged.connect(function (route) {
            if (route) {
              commit(SET_ROUTE, { route: route })
            } else {
              commit(RESET_ROUTE)
            }
          })
        }
      } else {
        console.error('Indoorviewer must be set before initalizing its components')
      }
    },
    async [SET_IV_LEVELS]({ commit, state }, payload) {
      let floors = []
      if (!payload.reset) {
        floors =
          payload.frame === 1
            ? ivApi?.view.floorChangerService.FloorChangerService.floors
            : ivApi2?.view.floorChangerService.FloorChangerService.floors
        await new Promise((resolve) => setTimeout(resolve, 2000))
        if (floors?.length) {
          let images = null
          // Outcommented code in this request relates to checking if levels have panoramas
          // If a level has no panorama, the button will be disabled
          // Removed due to performance issues
          /*
          let siteModel
          // Fetching images info (be aware that this request is very slow for large instances!)
          images = getIndoorviewerImages(
            frame === 1 ? this.navvisInstanceURL : this.navvisInstanceURL2,
            this.navvisApiToken
          )
          await new Promise((resolve) => setTimeout(resolve, 8000))
          // Checking if images have been set
          */
          if (!images) {
            // Proceeding without images (pretending each level has panoramas)
            floors.forEach((level) => {
              level.hasPanorama = true
            })
          }
          /*
          if (images.length) {
            // Fetching site model to match images with levels
            siteModel = await navvisRestApiRequest(
              frame === 1 ? this.navvisInstanceURL : this.navvisInstanceURL2,
              'api/site_model',
              this.navvisApiToken
            )
            floors.forEach((level) => {
              level.hasPanorama = checkForPanoramaImages(level.id, images, siteModel)
            })
          }
          */
        }
      }
      if (payload.frame === 1) {
        commit(SET_IV_LEVELS_FOR_FRAME, { frame: 1, floors: floors?.length ? floors : null })
      } else {
        commit(SET_IV_LEVELS_FOR_FRAME, { frame: 2, floors: floors?.length ? floors : null })
      }
    },
    [RESET_IVION_INSTANCES]({ commit }) {
      commit(CHANGE_PRIMARY_INSTANCE, null)
      commit(CHANGE_SECONDARY_INSTANCE, null)
      commit(SET_SPLIT_INDOORVIEWER, { splitIndoorViewer: false })
    },
    togglePoiGroup({ commit, state }, { id, visible }) {
      const updatedPoiTypes = [...state.poiTypes]
      const poiGroup = updatedPoiTypes.find((group) => group.id === id)
      poiGroup.visible = visible
      poiGroup.types.forEach((type) => {
        type.visible = visible
        ivInstance.setPoiTypesVisibility(visible, [type.id])
      })
      ivInstance.setPoiTypesVisibility(visible, [id])
      commit('setPoiTypesVisibility', updatedPoiTypes)
    },
    togglePoiType({ commit, state }, { id, visible }) {
      const updatedPoiTypes = [...state.poiTypes]
      updatedPoiTypes.some((group) => {
        const foundType = group.types.find((type) => type.id === id)
        if (foundType) {
          foundType.visible = visible
          group.visible = group.types.some((type) => type.visible)
          ivInstance.setPoiTypesVisibility(visible, [foundType.id])
          ivInstance.setPoiTypesVisibility(group.visible, [group.id])
          return
        }
      })
      commit('setPoiTypesVisibility', updatedPoiTypes)
    }
  }
}
